import { render, staticRenderFns } from "./relationGraph.vue?vue&type=template&id=11c970ac&scoped=true"
import script from "./relationGraph.vue?vue&type=script&lang=js"
export * from "./relationGraph.vue?vue&type=script&lang=js"
import style0 from "./relationGraph.vue?vue&type=style&index=0&id=11c970ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c970ac",
  null
  
)

export default component.exports